
export const companyTabs = {
  details: 'Details',
  locations: 'Locations',
  departments: 'Departments',
  contacts: 'Contacts',
  payment: 'Payment Methods',
  rates: 'Custom Rates',
  workers: 'Workers'
};

export const teaser = 'Coming Soon';

export const creditCardBrands = {
  visa: 'visa',
  mastercard: 'mastercard',
  discover: 'discover',
  unionpay: 'unionpay',
  jcb: 'jcb',
  'diners club': 'diners club',
  'american express': 'american express'
};

export const taxTypes = {
  W2: 'W2',
  Ten99M: '1099M'
};

export const paymentFieldsMaxLengths = {
  cardNumber: 19,
  cvc: 4,
  month: 2,
  year: 4
};



// WEBPACK FOOTER //
// ./src/constants/companies.js